export function getGangsheetDownloadLabel(file, index = 0) {
  const n = index + 1;
  const label = String(file?.label || "").toLowerCase();
  const link = String(file?.link || file?.url || "").toLowerCase();

  let filename = "";
  const m = link.match(/filename=([^&]+)/i);
  if (m) {
    try {
      filename = decodeURIComponent(m[1]).toLowerCase();
    } catch (e) {
      filename = m[1].toLowerCase();
    }
  }

  // Filename in Jiffy URL is source of truth (mixed orders)
  if (filename.includes("precut") || link.includes("precut") || label.includes("precut")) {
    return "Download PreCut";
  }
  if (filename.includes("procolor") || link.includes("procolor-jsgang")) {
    return `Download ProColor Link-${n}`;
  }
  if (filename.includes("uv-jsgang") || filename.startsWith("uv-") || link.includes("uv-jsgang")) {
    return `Download UV Link-${n}`;
  }
  if (filename.includes("transfers-jsgang") || filename.startsWith("transfers-") || link.includes("transfers-jsgang")) {
    return `Download DTF Link-${n}`;
  }

  // Fallback to stored label only if filename missing
  if (label.includes("procolor")) return `Download ProColor Link-${n}`;
  if (label.includes("uv")) return `Download UV Link-${n}`;
  return `Download DTF Link-${n}`;
}
